import { render } from "./VirologySectionDetailsDonorEMROATS.vue?vue&type=template&id=a5b799f2&scoped=true"
import script from "./VirologySectionDetailsDonorEMROATS.vue?vue&type=script&lang=js"
export * from "./VirologySectionDetailsDonorEMROATS.vue?vue&type=script&lang=js"

import "./VirologySectionDetailsDonorEMROATS.vue?vue&type=style&index=0&id=a5b799f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5b799f2"],['__file',"src/components/VirologySectionDetailsDonorEMROATS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5b799f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5b799f2', __exports__)) {
    api.reload('a5b799f2', __exports__)
  }
  
  module.hot.accept("./VirologySectionDetailsDonorEMROATS.vue?vue&type=template&id=a5b799f2&scoped=true", () => {
    api.rerender('a5b799f2', render)
  })

}


export default __exports__